import { Alert, Box, Typography } from "@mui/joy";

import { useCompetitionQuery, useCurrentCompetitionUuid } from "@/hooks/competitions";

import { ButtonLink } from "../Links";

export default function PublishResultsAlert() {
  const competitionUuid = useCurrentCompetitionUuid();
  const { data: competition } = useCompetitionQuery(competitionUuid);

  const resultsPending = competition?.status === "PENDING_RESULTS";
  if (!resultsPending) {
    return null;
  }
  return (
    <Alert
      sx={{
        maxWidth: 800,
        marginBottom: 2,
        borderWidth: 2,
        borderColor: "primary.400",
      }}
      variant="outlined"
    >
      <Box sx={{ flex: 1 }}>
        <Typography level="title-md" fontWeight="bold" color="primary">
          Results ready for review
        </Typography>
        <Typography level="body-sm">
          Please review the results on the competitors screen and hit Publish to make the results
          public.
        </Typography>
      </Box>
      <ButtonLink
        to="/gym/$venueUuid/events/$competitionUuid/competitors"
        from="/gym/$venueUuid/events/$competitionUuid"
      >
        Review
      </ButtonLink>
    </Alert>
  );
}
